/**
 * Patient section provider for Global Search (list API → SearchHit).
 * Reference implementation when adding a new `*SearchProvider` — then register it in
 * `shared/search/registerBuiltinProviders.ts`.
 */

import { formatPersonName } from '@/shared/utils/personName';
import type { GlobalSearchSectionProvider } from '@/shared/search/types';
import { patientAPI } from '../api/patient.api';

export const patientSearchProvider: GlobalSearchSectionProvider = {
  id: 'patients',
  permission: 'patients:read',
  titleKey: 'globalSearchPatients',
  iconId: 'patients',
  rankByAcronym: true,
  search: async (query, { limit, signal }) => {
    const res = await patientAPI.getPatients(
      { search: query, limit },
      { allClinics: false, signal },
    );
    return (res.data ?? []).slice(0, limit).map((p) => {
      const pid = p._id || p.id || '';
      return {
        id: pid,
        sectionId: 'patients',
        primary: formatPersonName(p, p.name || '') || p.patientId || pid,
        secondary: [p.patientId, p.phone].filter(Boolean).join(' · ') || undefined,
        path: `/patients/${pid}`,
      };
    });
  },
};
